import { Container } from "reactstrap";
import Header from "components/Headers/Header.js";
import { useState } from "react";
import { useCreateToken, useGetAllTokens } from "lib/api-tokens";
import LoadingSpinner from "components/Common/LoadingSpinner";
import ErrorAlert from "components/Common/ErrorAlert";
import NotificationAlert from "components/Common/NotificationAlert";
import TokensStatsCards from "components/Tokens/TokensStatsCards";
import TokensTable from "components/Tokens/TokensTable";
import AddTokenModal from "components/Tokens/AddTokenModal";

const Tokens = () => {
    const [modal, setModal] = useState(false);
    const [alert, setAlert] = useState({
        show: false,
        message: "",
        color: "",
        duration: 3000,
    });
    const [formData, setFormData] = useState({
        coinId: "",
        networkId: "",
        coinGeckoId: "",
        name: "",
        symbol: "",
        nameShort: "",
        symbolShort: "",
        binanceName: "",
        addressRegex: "",
        logoUrl: "",
        contractAddress: "",
        isToken: false,
        isMainnet: false,
        precisionDeposit: 2,
        precisionWithdraw: 2,
        price: 0,
    });

    const {
        data: tokensResponse,
        isLoading,
        isError,
        error,
        refetch,
    } = useGetAllTokens();

    const createTokenMutation = useCreateToken({
        onSuccess: (data) => {
            showAlert("Token created successfully!", "success");
            refetch();
            resetForm();
            toggle();
        },
        onError: (error) => {
            showAlert(
                `Error creating token: ${error.message || "Unknown error"}`,
                "danger",
                3000
            );
        },
    });

    const toggle = () => setModal(!modal);

    const showAlert = (message, color, duration = 3000) => {
        setAlert({ show: true, message, color, duration });
    };

    const hideAlert = () => {
        setAlert({ show: false, message: "", color: "" });
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : type === "number"
                    ? parseFloat(value) || 0
                    : value,
        }));
    };

    const resetForm = () => {
        setFormData({
            coinId: "",
            networkId: "",
            coinGeckoId: "",
            name: "",
            symbol: "",
            nameShort: "",
            symbolShort: "",
            binanceName: "",
            addressRegex: "",
            logoUrl: "",
            contractAddress: "",
            isToken: false,
            isMainnet: false,
            precisionDeposit: 2,
            precisionWithdraw: 2,
            price: 0,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        createTokenMutation.mutate(formData);
    };

    const tokensData = tokensResponse || [];

    if (isLoading) {
        return (
            <>
                <Header />
                <LoadingSpinner message="Loading tokens..." />
            </>
        );
    }

    if (isError) {
        return (
            <>
                <Header />
                <ErrorAlert error={error} onRetry={refetch} />
            </>
        );
    }

    return (
        <>
            <Header />
            <Container className="mt--7" fluid>
                <NotificationAlert alert={alert} onClose={hideAlert} />

                <TokensStatsCards tokensData={tokensData} />

                <TokensTable
                    tokensData={tokensData}
                    onAddToken={toggle}
                    isLoading={createTokenMutation.isLoading}
                />

                <AddTokenModal
                    isOpen={modal}
                    toggle={toggle}
                    formData={formData}
                    handleInputChange={handleInputChange}
                    handleSubmit={handleSubmit}
                    isLoading={createTokenMutation.isLoading}
                />
            </Container>
        </>
    );
};

export default Tokens;
